import { render, staticRenderFns } from "./TestsWidget.vue?vue&type=template&id=7c0c6933"
import script from "./TestsWidget.vue?vue&type=script&lang=js"
export * from "./TestsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports